<template>
  <a-row type="flex" justify="center" align="middle" style="min-height: 100vh">
    <a-col :sm="20" :md="20" :lg="20">
      <div class="centered">
        <a-col :xs="20" :md="12">
          <a-typography-title
            style="bottom: 0px; font-family: 'Urbanist'; text-align: center"
          >
            Este enlace expiró, pero no te preocupes!
          </a-typography-title>
        </a-col>

        <img src="@/assets/images/token-expired.svg" class="centered-image" />
        <br />

        <a-col :xs="20" :md="12">
          <a-typography-title
            style="
              bottom: 0px;
              font-family: 'Urbanist';
              text-align: center;
              color: #273cf5;
            "
          >
            Presiona el siguiente botón para reenviar:
          </a-typography-title>
        </a-col>

        <DownOutlined class="arrow-icon bounce" />

        <a-button
          :loading="state.loadingResend"
          @click="handleResend"
          type="primary"
          size="large"
          class="main-action"
        >
          Enviar nuevo enlace
        </a-button>

        <br />

        <a-col :xs="20" :md="12">
          <p class="instruction">
            El enlace llegará al mismo correo donde recibiste el anterior.
          </p>
        </a-col>
      </div>
    </a-col>
  </a-row>
</template>

<script setup>
import { onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  FETCH_DEPENDENTS_INCORPORATION_FORM,
  POST_RESEND_DEPENDENTS_INCORPORATION_NO_DELIVERABLE_FORM
} from '@/store/types';
import notification from '@/utils/notifications';
import { DownOutlined } from '@ant-design/icons-vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const state = reactive({
  loading: true,
  loadingResend: false
});

const handleResend = async () => {
  try {
    state.loadingResend = true;
    const response = await store.dispatch(
      POST_RESEND_DEPENDENTS_INCORPORATION_NO_DELIVERABLE_FORM,
      route.params.token
    );
    if (!response.status) {
      throw new Error('No se envió el correo');
    }
    notification(
      'success',
      'Enviado',
      'Se ha enviado un nuevo correo con el formulario de incorporación de cargas.'
    );
  } catch (error) {
    notification(
      'error',
      'Error',
      'No se pudo reenviar el correo. Intentalo más tarde.'
    );
  } finally {
    state.loadingResend = false;
  }
};

onMounted(async () => {
  try {
    const form = await store.dispatch(
      FETCH_DEPENDENTS_INCORPORATION_FORM,
      route.params.token
    );
    state.form = form;
    if (form.state !== 'Creado') {
      router.push({ name: 'DependentsIncorporationNoDeliverableFormError' });
    }
    state.loading = false;
  } catch (error) {
    if (error?.response?.status === 401) {
      state.loading = false;
      return;
    }
    router.push({ name: 'DependentsIncorporationNoDeliverableFormError' });
  }
});
</script>
<style scoped>
.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
}

.centered-image {
  height: 280px;
}

:deep(.ant-typography) {
  margin-bottom: 20px;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(8px);
  }
}

.bounce {
  animation: bounce 1.1s infinite;
}

.arrow-icon {
  font-size: 25px;
  color: #273cf5;
  margin: 15px 0 15px;
}

.instruction {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 12px;
}

.main-action {
  height: 64px;
  font-size: 20px;
  padding: 0 10px;
  font-weight: 600;
}
</style>
